import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import TableComponent from 'UiKit/table-component';
import PreviewImage from 'UiKit/preview-image';

import { useReportAttendanceOperatorDetailState } from 'View/report-attendance-operator-detail/state';
import { getTableList } from 'View/report-attendance-operator-detail/helper/getTableList';
import { TableSkeleton } from 'View/report-attendance-operator-detail/component/skeleton';

import styles from './styles.module.css';

const Table = ({ data, isFetching }) => {
  const { selectedTab, isOpenImagePreview, selectedImagePreview, filterState, updateState, updateFilterState } = useReportAttendanceOperatorDetailState();

  const handleClosePreview = () => updateState({ isOpenImagePreview: false, selectedImagePreview: [] });

  const onChangePagination = (page) => updateFilterState({ page });

  const handleOpenPreview = (images) => updateState({ isOpenImagePreview: true, selectedImagePreview: images });

  const tableList = getTableList(selectedTab, handleOpenPreview);

  return (
    <Box className={styles['table__container']}>
      <Box className={styles['table__wrapper']}>
        <Condition statement={!isFetching} fallback={<TableSkeleton />}>
          <TableComponent
            columns={tableList}
            dataSource={data?.dataSource}
            isDataExist={data?.isDataExist}
            maxTableHeight="calc(100vh - 410px)"
            maxTableBodyHeight="calc(100vh - 465px)"
            tableComponentHeight="calc(100vh - 320px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: data?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Condition>
      </Box>

      <PreviewImage images={selectedImagePreview} isOpen={isOpenImagePreview} onClose={handleClosePreview} initialIndex={0} />
    </Box>
  );
};

export default Table;
